import React from 'react';
import { useParams } from 'react-router-dom';

import TestEditor from './editor';

export default function EditTest() {
    const {
        level = '',
        skill = '',
        testId = ''
    } = useParams();

    return (
        <TestEditor
            isNew={false}
            level={level}
            skill={skill}
            testId={testId}
        />
    );
}